/**
 * @generated SignedSource<<567148a7314663b5a0334acdfc07576c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LibraryRows_musicViewer$data = {
  readonly pieces: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"LibraryRow_piece">;
  }>;
  readonly " $fragmentType": "LibraryRows_musicViewer";
};
export type LibraryRows_musicViewer$key = {
  readonly " $data"?: LibraryRows_musicViewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"LibraryRows_musicViewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LibraryRows_musicViewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MusicPiece",
      "kind": "LinkedField",
      "name": "pieces",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "LibraryRow_piece"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MusicViewer",
  "abstractKey": null
};

(node as any).hash = "fb96b339d19787eed377ce221d7f6164";

export default node;
